// extracted by mini-css-extract-plugin
export var buttonContainer = "_8b-1";
export var fontSizeSelect = "_8b-3";
export var formatSelect = "_8b-2";
export var formats = "_8b-4";
export var hidden = "_8b-5";
export var icon = "_8b-6";
export var select = "_8b-0";